import { useSelector, useDispatch } from 'react-redux'

import Confirmation from 'components/export/confirmation'

import { confirmationOpenSelector, closeConfirmation } from './slice'

export const UsersExportConfirmation = () => {
  const open = useSelector(confirmationOpenSelector)
  const dispatch = useDispatch()

  return open && <Confirmation onConfirm={() => dispatch(closeConfirmation())} />
}
